import { render, staticRenderFns } from "./gameActivity.vue?vue&type=template&id=bd9fac84&"
import script from "./gameActivity.vue?vue&type=script&lang=js&"
export * from "./gameActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports